Namespace 'Customer.Reports'

class Customer.Reports.OperatorAvailabilityReportItem extends Backbone.Model
  defaults:
    operator_name: ''
    users_group_name: ''
    assigned_tickets_count: 0
    average_assigned_time_milliseconds: 0
    operator_status: ''
    operator_status_time_milliseconds: 0
    assigned_tickets_pending_count: 0

class Customer.Reports.OperatorAvailabilityReportItemCollection extends Backbone.Collection
  model: Customer.Reports.OperatorAvailabilityReportItem
